export default __webpack_public_path__ + "static/media/CNo.89-2.111b3db8.jpg";